import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import {Email, Lock} from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import Link from "react-router-dom/es/Link";
import {useDispatch, useSelector} from "react-redux";
import userAction from "../../../actions/user.action";
import ErrorMessage from "../../../components/UI/ErrorMessage";

const LoginForm = ({classes}) => {
  const [form, setForm] = useState({
    email: '',
    password: ''
  });
  const dispatch = useDispatch();
  const userState = useSelector((store) => store.user);

  const handleChange = e => {
    e.preventDefault();
    const { name, value } = e.target;
    setForm({...form, [name]: value });
  };


  const handleLogin = e => {
    e.preventDefault();
    dispatch(userAction.login(form));
  };

  return (
    <form
      className={classes.form}
      onSubmit={handleLogin}
    >
      {!userState.loggedIn && userState.message && (
        <ErrorMessage>{userState.message}</ErrorMessage>
      )}
      <div>
        <TextField
          label="Email Address"
          name="email"
          type="email"
          onChange={handleChange}
          margin="normal"
          required
          fullWidth
          value={form['email']}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Email />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Password"
          name="password"
          type="password"
          onChange={handleChange}
          margin="normal"
          required
          fullWidth
          value={form['password']}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Lock />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="secondary"
          className={`${classes.cta} ${classes.signinBtn}`}
        >
          Sign in
        </Button>
        <Link to="/forgot-password" className={classes.pwBtn}>
          <Button fullWidth className={classes.cta}>
            Forgot Password
          </Button>
        </Link>
      </div>
    </form>
  )
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/containers/Login/components/LoginForm.jsx